import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    // Get dynamic semantic design token,
    // which can automatically switch between light and dark content
    const semantic = getDynamicSemanticToken(theme);
    const { typography } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        margin: 16,
        padding: 10,
        fontSize: {
            title: typography.fontSize.bodyLargeBold,
            body: typography.fontSize.body,
        },
        fontFamily: typography.fontFamily,
        fontWeight: {
            title: typography.fontWeight.bodyLargeBold,
            body: typography.fontWeight.body,
        },
        color: {
            title: semantic.text.stronger.neutral,
            body: semantic.text.neutral,
        },
    };
}
